<template>
  <div class="container">
    <div
      class="content-padding"
      :style="{
        backgroundColor:
          (activityInfo && activityInfo.new_background) || '#ece7ff'
      }"
    >
      <div class="content" v-if="info">
        <img class="head-bg" :src="info.new_head_img" alt="" />
        <div class="b-content">
          <div class="user-info" v-if="info">
            <img class="avatar" :src="info.head_img" alt="" />
            <div class="nickname">{{ info.truename | filterName }}</div>
          </div>
          <!-- 邀请码 -->
          <div
            class="invite-code"
            v-if="activityInfo.activity_type == 3"
            @click="bindClickCopy"
            :data-clipboard-text="code"
            ref="copy1"
          >
            <span class="number">{{ code }}</span>
            <span class="copy">复制</span>
          </div>
          <img class="a-image" :src="info.new_prize_img" alt="" />
        </div>

        <div class="rule-btn" @click="jumpRules">活动规则</div>
        <!-- 案例库 -->
        <div>
          <van-swipe
            class="my-swipe"
            :autoplay="10000"
            :show-indicators="false"
            :loop="false"
            @change="changeSwipe"
          >
            <van-swipe-item
              class="swipe-item"
              v-for="(item, index) in caseList"
              :key="index"
            >
              <img class="swipe-image" :src="item" alt="" />
            </van-swipe-item>
          </van-swipe>
          <div class="indicators-list">
            <div
              class="indicators-item"
              :class="{ 'indicators-item-active': curSwipe == index }"
              v-for="(item, index) in caseList"
              :key="index"
            ></div>
          </div>
          <img
            class="logo"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
            alt=""
          />
        </div>
      </div>
    </div>
    <div
      class="btn-content"
      :class="{ 'disabled-btn': info.activity_state != 1 }"
      @click="bindReceive"
      v-if="info"
      :data-clipboard-text="code"
      ref="copy2"
    >
      <div v-if="info.activity_state == 0">活动未开始</div>
      <div v-if="info.activity_state == 1">
        <div class="text">{{ info.new_button_words || '免费领取' }}</div>
      </div>
      <div v-if="info.activity_state == 2">活动已结束</div>
    </div>
    <van-overlay :show="showLogin" @click="showLogin = false">
      <LoginComponent
        v-if="showLogin"
        class="login-content"
        @close="bindLoginClose"
        @login="bindLogin"
      />
    </van-overlay>
    <van-loading
      class="v-loading"
      v-if="!loaded"
      text-color="#55417A"
      color="#55417A"
      vertical
      >加载中...</van-loading
    >
  </div>
</template>
<script>
import LoginComponent from './components/login.vue'
import Clipboard from 'clipboard'
export default {
  components: {
    LoginComponent
  },
  data() {
    return {
      errorText: false,
      isFirst: true, //是否是第一次请求
      showLogin: false,
      loaded: false,
      info: null,
      activityInfo: null,
      code: '',
      curSwipe: 0,
      caseList: [
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/34568a36490555df7133f0d252d78b82.png',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5fd70b724f22ac7fef9d132f16b7a5da.png',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/19060b98d260c152d7764eb5fa73653c.png',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8f89cd9d5eb9bd74e736aaf43394dea8.png',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3239931c9e3296ea43f4b0b7e4087618.png'
      ]
    }
  },
  filters: {
    filterName(name) {
      if (!name) {
        return ''
      }
      if (name.length > 10) {
        name = name.slice(0, 7) + '..'
      }
      return name
    }
  },
  created() {
    this.code = this.$route.query.code
    this.getData()
    //分享活动落地页曝光事件
    this.$buryPoint('APP_SHARE_ACTIVITY_V2_RECEIVE_PAGE', {})
  },
  methods: {
    bindClickCopy() {
      if (this.info.activity_state == 0) {
        this.$toast('活动未开始')
        return
      }
      if (this.info.activity_state == 2) {
        this.$toast('活动已结束')
        return
      }
    },
    changeSwipe(index) {
      this.curSwipe = index
    },
    jumpRules() {
      this.$router.push({
        path: '/camp-invite-common/rules',
        query: {
          type: 0,
          activityId: this.$route.query.aid,
          backgroundColor: this.activityInfo.background
        }
      })
    },
    getData() {
      let params1 = {
        invitation_id: this.$route.query.iid,
        activity_id: this.$route.query.aid
      }
      let params2 = {
        id: this.$route.query.aid
      }
      let res1 = this.$http.getBaseApp(
        'member/ActivitySys/getInvitationDetail',
        params1
      )
      let res2 = this.$http.getBaseApp(
        'member/ActivitySys/getActivityInfo',
        params2
      )
      Promise.all([res1, res2])
        .then((res) => {
          let res1 = res[0].data
          let res2 = res[1].data
          if (res1.code === 200 && res2.code === 200) {
            this.info = res1.data
            this.activityInfo = res2.data
            document.title = res2.data.show_title || ''
            this.initCopy()
          } else if (res1.code != 200) {
            this.$toast(res1.msg)
          } else if (res2.code != 200) {
            this.$toast(res2.msg)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loaded = true
        })
    },
    initCopy() {
      if (
        this.activityInfo.activity_type == 3 &&
        this.info.activity_state == 1
      ) {
        this.$nextTick(() => {
          let dom1 = this.$refs.copy1
          let dom2 = this.$refs.copy2
          if (dom1) {
            this.clipboard1 = new Clipboard(dom1)
            this.clipboard1.on('success', () => {
              this.$toast('复制邀请码成功')
            })
            this.clipboard1.on('error', () => {
              this.$toast('复制失败，请手动复制')
            })
          }
          if (dom2) {
            this.clipboard2 = new Clipboard(dom2)
            this.clipboard2.on('success', () => {
              this.$toast('复制邀请码成功')
            })
            this.clipboard2.on('error', () => {
              this.$toast('复制失败，请手动复制')
            })
          }
        })
      }
    },
    bindLoginClose() {
      this.showLogin = false
    },
    //登陆领取
    bindLogin(options) {
      let { username, phone, code } = options
      let params = {
        phone: phone,
        invitation_id: this.$route.query.iid,
        activity_id: this.$route.query.aid,
        pid: this.$route.query.pid,
        cid: this.$route.query.cid,
        areaCode: '86',
        identify_code: code,
        truename: username,
        from: '1',
        gender: '0'
      }
      this.$http
        .getBaseApp('member/ActivitySys/receive', params)
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            if (res.data && res.data.data) {
              sessionStorage.setItem('token', res.data.data || '')
              localStorage.setItem('token', res.data.data || '')
            }
            this.showLogin = false
            this.$toast(res.data.msg || '领取成功')
            //分享活动落地页领取成功
            this.$buryPoint('APP_SHARE_ACTIVITY_V2_RECEIVE_PAGE_SUCCESS', {})
            setTimeout(() => {
              this.$router.push({
                path: '/camp-invite-common/receive',
                query: {
                  status: res.data.msg,
                  activityType: this.activityInfo.activity_type,
                  activityId: this.$route.query.aid,
                  pid: this.$route.query.pid,
                  cid: this.$route.query.cid
                }
              })
            }, 300)
          } else {
            this.$dialog.alert({
              title: '提示',
              message: res.msg
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    bindReceive() {
      if (this.info.activity_state == 0) {
        this.$toast('活动未开始')
        return
      }
      if (this.info.activity_state == 2) {
        this.$toast('活动已结束')
        return
      }
      if (this.errorText) {
        this.$toast(this.errorText)
        return
      }
      //分享活动落地页点击领取事件
      this.$buryPoint('APP_SHARE_ACTIVITY_V2_RECEIVE_PAGE_BUTTON', {})
      if (this.activityInfo.activity_type != 3) {
        this.showLogin = true
      } else {
        setTimeout(() => {
          location.href = 'https://member3.gymcity.com.cn/#/app-download'
        }, 1000)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  background: #ece7ff;
  min-height: 100vh;

  .content-padding {
    box-sizing: border-box;
    padding-bottom: 60px;
  }

  .content {
    position: relative;
  }

  .head-bg {
    width: 100%;
  }

  .b-content {
    position: relative;
    margin-bottom: 20px;

    .user-info {
      width: 80%;
      position: absolute;
      left: 50%;
      top: 48px;
      transform: translate(-50%, 0%);
      display: flex;
      align-items: center;
      justify-content: center;

      .avatar {
        border-radius: 50%;
        object-fit: cover;
        overflow: hidden;
        width: 30px;
        height: 30px;
        margin-right: 9px;
      }

      .nickname {
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 20px;
        white-space: nowrap;
        max-width: 200px;
      }
    }

    .invite-code {
      width: 184px;
      position: absolute;
      left: 142px;
      bottom: 218px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      line-height: 20px;
      display: flex;
      align-items: center;

      .number {
        flex-shrink: 0;
        max-width: 144px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .copy {
        margin-left: 4px;
        color: #6236ff;
      }
    }

    .a-image {
      width: 100%;
    }
  }

  .my-swipe {
    margin-bottom: 16px;

    .swipe-image {
      margin: 0 auto;
      width: 335px;
      height: 379px;
    }
  }

  .indicators-list {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 26px;

    .indicators-item {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.12);
      margin-right: 4px;
    }

    .indicators-item-active {
      width: 12px;
      height: 5px;
      background: #6236ff;
      border-radius: 3px;
    }
  }

  .logo {
    margin: 0 auto 24px;
    height: 18px;
  }

  .user-content {
    position: absolute;
    width: 100%;
    padding: 0px 44px;
    left: 0;
    top: 80px;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .avatar {
      object-fit: cover;
      width: 36px;
      height: 36px;
      border-radius: 6px;
      margin-right: 12px;
    }

    .user-right {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;

      .username {
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #df687d;
        line-height: 22px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .user-desc {
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #55417a;
        line-height: 14px;
      }
    }
  }

  .btn-content {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    text-align: center;
    height: 48px;
    // IOS底部兼容
    height: calc(48px + 0.5 * constant(safe-area-inset-bottom)); //兼容 IOS<11.2
    height: calc(48px + 0.5 * env(safe-area-inset-bottom)); //兼容 IOS>11.2
    background: #fe3875;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .text {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 22px;
    }

    .del {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(255, 255, 255, 0.5);
      line-height: 17px;
      text-decoration: line-through;
    }
  }

  .disabled-btn {
    background-color: #999;
    color: #fff;
  }

  .login-content {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
  }
}

.v-loading {
  position: fixed;
  left: 50%;
  top: 30%;
  transform: translate(-50%, 0%);
  z-index: 1;
}

.rule-btn {
  position: fixed;
  right: 0;
  top: 110px;
  width: 25px;
  display: flex;
  text-align: center;
  background: rgb(51, 51, 51);
  border-radius: 8px 0px 0px 8px;
  padding: 8px 4px;
  box-sizing: border-box;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 15px;
  z-index: 1;
}
</style>
